// components/FullPageLoader.js
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const FullPageLoader = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
    >
      <CircularProgress size={60} thickness={5} />
      <Typography variant="h6" mt={2} color="textSecondary">
        Loading...
      </Typography>
    </Box>
  );
};

export default FullPageLoader;